"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExerciseSeriesParameters = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const typography_1 = require("../../shared/typography");
const styled_components_1 = __importDefault(require("styled-components"));
const ExerciseSeriesParameters = ({ seriesData }) => {
    if (!(seriesData === null || seriesData === void 0 ? void 0 : seriesData.length))
        return null;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: seriesData.map((series) => {
            return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)(typography_1.P, { children: [series.parameter.name, " (", series.unit, ")"] }, void 0), (0, jsx_runtime_1.jsx)(SetsWrapper, { children: series.series.map((set, key) => {
                                    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(typography_1.P, { children: set || "-" }, void 0) }, key));
                                }) }, void 0)] }, void 0), series.series.length > 0 && ((0, jsx_runtime_1.jsxs)(CalculationsWrapper, { children: [series.parameter.options.calculations.includes("average") && ((0, jsx_runtime_1.jsxs)(CalculationWrapper, { children: [(0, jsx_runtime_1.jsx)(typography_1.P, { children: "Gemiddelde" }, void 0), (0, jsx_runtime_1.jsx)(SetsWrapper, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(typography_1.P, { children: (series.series.reduce((a, v) => (a = a + v)) /
                                                    series.series.length).toFixed(1) }, void 0) }, void 0) }, void 0)] }, void 0)), series.parameter.options.calculations.includes("total") && ((0, jsx_runtime_1.jsxs)(CalculationWrapper, { children: [(0, jsx_runtime_1.jsx)(typography_1.P, { children: "Totaal" }, void 0), (0, jsx_runtime_1.jsx)(SetsWrapper, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(typography_1.P, { children: (series.series.reduce((a, v) => (a = a + v)) || 0).toFixed(1) }, void 0) }, void 0) }, void 0)] }, void 0))] }, void 0))] }, series.parameter.name));
        }) }, void 0));
};
exports.ExerciseSeriesParameters = ExerciseSeriesParameters;
const CalculationsWrapper = styled_components_1.default.div `
  display: flex;
  width: 130px;
`;
const CalculationWrapper = styled_components_1.default.div `
  padding: 0 5px;
`;
const SetsWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;

  & > div {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;

    &:not(:last-of-type) {
      margin-right: ${({ theme }) => theme.spacings.xs};
    }

    p {
      align-items: center;
      background-color: ${({ theme }) => theme.colors.silverBase};
      border-radius: ${({ theme }) => theme.utils.radius};
      display: flex;
      font-size: 0.75rem;
      font-weight: 500;
      justify-content: center;
      width: 2.5rem;
    }

    p:first-of-type {
      margin-bottom: ${({ theme }) => theme.spacings.xs};
    }
  }
`;
//# sourceMappingURL=ExerciseSeriesParameters.js.map